import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useUserContext } from '../../contexts/UserContext';
import { verifySession } from '../../utils/APIs';
import Loader from '../../components/UI/Loader/Loader';

const PaymentSuccess = () => {
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id');
    const navigate = useNavigate();
    const { updateSelectedOrgData } = useUserContext();
    const [verifying, setVerifying] = useState(true);

    useEffect(() => {
        const verifyPayment = async () => {
            if (!sessionId) {
                navigate('/dashboard');
                return;
            }

            try {
                // We might want to wait a bit for the webhook to process
                // or verify the session status directly
                const res = await verifySession(sessionId);
                if (res.status && res.data.paymentStatus === 'paid') {
                    toast.success("Payment successful! Your plan has been updated.");
                    await updateSelectedOrgData();
                } else if (res.data.paymentStatus === 'unpaid') {
                    navigate('/payment/processing');
                    return;
                }
            } catch (error) {
                console.error("Verification error:", error);
            } finally {
                setVerifying(false);
            }
        };

        verifyPayment();
    }, [sessionId, navigate, updateSelectedOrgData]);

    if (verifying) {
        return <Loader message="Verifying your payment..." />;
    }

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
            <div className="bg-green-100 p-6 rounded-full mb-6">
                <svg className="w-16 h-16 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-4">Payment Successful!</h1>
            <p className="text-lg text-gray-600 mb-8 max-w-md">
                Thank you for your purchase. Your subscription has been activated and your account is now updated.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
                <button
                    onClick={() => navigate('/dashboard')}
                    className="px-8 py-3 bg-gray-100 text-gray-700 rounded-md font-medium hover:bg-gray-200 transition-colors"
                >
                    Go to Dashboard
                </button>
                <button
                    onClick={() => navigate('/settings/my-plan')}
                    className="px-8 py-3 bg-primary text-white rounded-md font-medium hover:bg-primary-dark transition-colors"
                >
                    Back to Billing
                </button>
            </div>
        </div>
    );
};

export default PaymentSuccess;
